import { CustomSectionState } from 'api/custom-section/types';
import { FC, useState } from 'react';
import { PeoplePageSourceDerivedSignalSectionComponentProps } from '../types';
import { PeoplePageSourceDerivedSignalSectionPromptInput } from './prompt-input';
import { PeoplePageSourceDerivedSignalSectionPromptPreview } from './prompt-preview';

export const PeoplePageSourceDerivedSignalSectionPrompt: FC<
  PeoplePageSourceDerivedSignalSectionComponentProps
> = (props) => {
  const [isEditing, setIsEditing] = useState(
    props.node.attrs.state === CustomSectionState.Open,
  );

  return (
    <div>
      {isEditing ? (
        <PeoplePageSourceDerivedSignalSectionPromptInput
          {...props}
          onEditDone={() => {
            setIsEditing(false);
          }}
        />
      ) : (
        <PeoplePageSourceDerivedSignalSectionPromptPreview
          {...props}
          onWrapperClick={() => {
            setIsEditing(true);
          }}
        />
      )}
    </div>
  );
};
